module.exports = __webpack_public_path__ + "static/media/fikfameika.d11f2ef1.jpg";